
const nameList = [
   
    {
        entityField: "bgmCode",
        showField: "商品编号",
        fieldWeight: 130,
        fieldType: "string",
        fixed:'left',
    },
    {
        entityField: "bgmName",
        showField: "通用名称",
        fieldWeight: 130,
        fieldType: "string",
        isRift: 1,
        riftField: "bgmId",
        fixed:'left',
    },
    {
        entityField: "spec",
        showField: "规格",
        fieldWeight: 90,
        fieldType: "string",
        fixed:'left',
    },
    {
        entityField: "manufacturer",
        showField: "生产厂商",
        fieldWeight: 180,
        fieldType: "string",
        fixed:'left',
    }, 
  
    {
        entityField: "bgpUnitmeasurement",
        showField: "单位",
        fieldWeight: 50,
        fieldType: "string",
        fixed:'left',
    }, 
    {
        entityField: "lotno",
        showField: "批次",
        fieldWeight: 140,
        fieldType: "string",
        fixed:'left',
    }, 
    {
        entityField: "batchno",
        showField: "批号",
        fieldWeight: 140,
        fieldType: "string",
        fixed:'left',
    }, 
     {
        entityField: "expidate",
        showField: "有效期",
        fieldWeight: 140,
        fieldType: "date",
        fixed:'left',
    }, 
    // {
    //     entityField: "packingSpec",
    //     showField: "装箱规格",
    //     fieldWeight: 70,
    //     fieldType: "string",
    //     fixed:'left',
    // },
    {
        entityField: "invNum",
        showField: "数量",
        fieldWeight: 60,
        fieldType: "string",
        fixed:'left',
    },
    //   {
  
    {
        entityField: "psprice",
        showField: "进价",
        fieldWeight:70,
        fieldType: "string",
        fixed:'left',
    },
    {
        entityField: "agreementPrice",
        showField: "协议价",
        fieldWeight:70,
        fieldType: "string",
        fixed:'left',
    },
    {
        entityField: "lowestPrice",
        showField: "最低售价",
        fieldWeight:120,
        fieldType: "input",
        // fixed:'left',
    },
    //右侧活动的，可以输入的
    // {
    //     entityField: "batchPrice1",
    //     showField: "配送价",
    //     fieldWeight:70,
    //     fieldType: "input",
    //     // fixed:'left',
    // },
    // {
    //     entityField: "batchPrice2",
    //     showField: "调拨价",
    //     fieldWeight:70,
    //     fieldType: "input",
    //     // fixed:'left',
    // },
    // {
    //     entityField: "batchPrice3",
    //     showField: "中标价",
    //     fieldWeight:70,
    //     fieldType: "input",
    //     // fixed:'left',
    // },
    // {
    //     entityField: "batchPrice4",
    //     showField: "电商价",
    //     fieldWeight:70,
    //     fieldType: "input",
    //     // fixed:'left',
    // },
    // {
    //     entityField: "batchPrice5",
    //     showField: "协议价",
    //     fieldWeight:70,
    //     fieldType: "input",
    //     // fixed:'left',
    // },


]
export default nameList
